import * as mobx from 'mobx';
import { MessageDescriptor } from 'react-intl';
import { AccountAdminSettingEntity } from '../common/account-admin-setting.entity';
import { BaseAccountAdminSettingViewModel } from '../common/base-account-admin-setting-form.viewmodel';
import {
    ACCOUNT_SUBDOMAIN_MANDATORY_TEXT,
    ACCOUNT_SUBDOMAIN_STATUS_UPDATED_TEXT,
} from './account-subdomain.text';
import { getWebsiteFieldValidationError } from '../../../infrastructure/utils/getWebsiteFieldValidationError';

class AccountSubdomainFormVM extends BaseAccountAdminSettingViewModel {
    @mobx.observable
    public isFormChecked: boolean = false;
    constructor(
        protected readonly entity: AccountAdminSettingEntity,
    ) {
        super(entity);
    }

    public get notificationMessage(): MessageDescriptor {
        return ACCOUNT_SUBDOMAIN_STATUS_UPDATED_TEXT;
    }

    @mobx.action
    public setFieldTouched = (): void => {
        this.isFormChecked = true;
    };

    @mobx.action
    public toggleAccountSubdomainEnabled = (): void => {
        this.entity.toggleEnabled();

        if (!this.entity.enabled) {
            this.isFormChecked = false;
        }
    };

    @mobx.action
    public handleChangeWebsiteInput(value: string): void {
        this.setFieldTouched();
        this.settingsEntity.setAdditionalData(value.trim());
    }

    public getSubdomainValidationMessage = (): string | string[] | null => {
        if (this.isSubdomainFieldEmpty()) {
            return this.intl.formatMessage(ACCOUNT_SUBDOMAIN_MANDATORY_TEXT);
        } else if (getWebsiteFieldValidationError(this.entity.additionalData as string)) {
            return getWebsiteFieldValidationError(this.entity.additionalData as string);
        } else {
            return null;
        }
    };

    public async apiCall(): Promise<void> {
        const resp = await this.accountAdminDAO.updateAccountSubdomainData({
           ...this.entity.getCommonAPIPayload(),
           accountSubdomainEnabled: this.entity.enabled,
           subdomain: this.entity.additionalData as string || null,
        });
        this.settingsEntity.setAdditionalData(resp.subdomain);
    }

    private isFormValid = (): boolean => {
        return !this.getSubdomainValidationMessage();
    };

    private isSubdomainFieldEmpty(): boolean {
        return this.entity.enabled && !this.entity.additionalData;
    }

    protected shouldInterruptSubmit(): boolean {
        return super.shouldInterruptSubmit() || !this.isFormValid();
    }

    protected onInteruptHandler(): boolean | void {
        if (!this.isFormValid()) {
            this.isFormChecked = true;
        }
    }
}

export { AccountSubdomainFormVM };